import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faUser } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModuleListItem, Form, Link, UserProfileImage,
} from '@domain-group/suit-theme'

import { UseAssignCampaignTeamOrAgentsPayload } from '@hooks/useAssignCampaignTeamOrAgents'

import AgentListItem from './AgentListItem'

interface SelectedAgentsAndTeamProps {
  assignCampaignTeamOrAgentsPayload: UseAssignCampaignTeamOrAgentsPayload,
  compact?: boolean,
}

const SelectedAgentsAndTeam = (props: SelectedAgentsAndTeamProps) => {
  const { assignCampaignTeamOrAgentsPayload, compact } = props

  const {
    agentIdsWithoutTeam,
    callbacks: {
      removeAgent,
      removeTeam,
    },
    campaignFormPayload,
    hasAssignedAgents,
    hasAssignedTeam,
    teamPayload,
  } = assignCampaignTeamOrAgentsPayload

  const {
    entityState: {
      team_id,
    },
  } = campaignFormPayload

  const { coverImage, team } = teamPayload

  return (
    <>
      {hasAssignedAgents && (
        <Form.Field
          label={team_id ? 'Additional Agents' : 'Selected Agents'}
          labelProps={{ marginBottom: 'none' }}
          marginTop="large"
        >
          {agentIdsWithoutTeam?.map((agentId: number) => (
            <AgentListItem
              agentId={agentId}
              callbacks={{ removeAgent }}
              compact
              key={agentId}
            />
          ))}
        </Form.Field>
      )}

      {hasAssignedTeam && (
        <Form.Field
          label="Selected Team"
          labelProps={{ marginBottom: 'none' }}
          marginTop={hasAssignedAgents && !compact ? 0 : 'large'}
        >
          <DashboardModuleListItem
            boxProps={{
              bottomBorder: compact ? 'none' : undefined,
              paddingX: '0',
              paddingY: compact ? 'medium' : undefined,
            }}
            imageComponent={(
              // @ts-expect-error TS2339
              <UserProfileImage imageUrl={coverImage?.thumb_url}>
                <FontAwesomeIcon icon={faUser} />
              </UserProfileImage>
                )}
            imageVariant="square"
            title={team.title}
          >
            <Link greyLink onClick={() => removeTeam()}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </Link>
          </DashboardModuleListItem>
        </Form.Field>
      )}
    </>
  )
}

export default SelectedAgentsAndTeam
